import { Form } from "@unform/web";
import React, { useCallback, useEffect } from "react";

import { Card, CardBody, CardFooter, Row, Col } from "reactstrap";
import apiGd from "services/apiGd";
import CheckboxInput from "views/components/Checkbox";
import { ButtonLink } from "./styles";

export default function CardSettings({
  menuEnable,
  systemEnable,
  setMenuEnable,
  setSystemEnable,
}) {
  const tokenGd = localStorage.getItem("@QRExpress:tokenGd");
  async function handleSetMenuEnable() {
    await apiGd.put(
      "/admin/settings",
      {
        name: "enable-menu",
        value: menuEnable === "true" ? "false" : "true",
      },
      {
        headers: { Authorization: `Bearer ${tokenGd}` },
      }
    );

    setMenuEnable(menuEnable === "true" ? "false" : "true");
  }

  async function handleSetClientEnable() {
    await apiGd.put(
      "/admin/settings",
      {
        name: "enable-clients",
        value: systemEnable === "true" ? "false" : "true",
      },
      { headers: { Authorization: `Bearer ${tokenGd}` } }
    );
    setSystemEnable(systemEnable === "true" ? "false" : "true");
  }

  return (
    <Card className="card-stats">
      <Form>
        <CardBody>
          <Row>
            <Col>
              <CheckboxInput
                name="suspend_gd"
                label="Suspender Garçom Digital dos Clientes"
                onChange={(e) => handleSetClientEnable(!e.target.value)}
                checked={systemEnable === "true" ? false : true}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CheckboxInput
                name="suspend_menu"
                label="Suspender Menus do Dashboard"
                onChange={(e) => handleSetMenuEnable(!e.target.value)}
                checked={menuEnable === "true" ? false : true}
              />
            </Col>
          </Row>
        </CardBody>
      </Form>
      <CardFooter>
        <hr />
        <div className="stats">
          <i className="fa fa-plus-slim" />
          <ButtonLink>Mais configurações</ButtonLink>
        </div>
      </CardFooter>
    </Card>
  );
}
